import { TestSuitePage } from '@live-webinar/broadcast';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/test-suite/camera'].update({
        staticData: { title: { page: 'TestSuite.Chooser.Camera.Title' } },
        component: authGuard(TestSuitePage)
    });
};
